// extracted by mini-css-extract-plugin
module.exports = {"trainee-list":"style_trainee-list__2oyRA"};